import Color from 'color';
import ColorScheme from 'color-scheme';
import { BInstrument } from './instrument';





// const { rad, speed } = config;


var scheme = new ColorScheme();
scheme.from_hue(21)
    .scheme('triade')
    .variation('soft');

var colors = scheme.colors().map((c: any) => '#' + c);



// const is

export const gridy = (
    canvasW: number,
    canvasH: number,
    boxes: number,
    dotCount: number,
    rhythm: number,
    rad: number,
    speed: number,
    lives: number,
    ins: BInstrument,
) => {

    const getGridIndex = (gridX: number, gridY: number) => {
        if (gridX < 0) gridX = 0;
        if (gridX > boxes - 1) gridX = boxes - 1;
        if (gridY < 0) gridY = 0;
        if (gridY > boxes - 1) gridY = boxes - 1;
        return ((boxes * gridY) + gridX);
    }

    // make the grid!
    const grid: { color: string, beating: number }[] = [];
    for (let x = 0; x < boxes; x++) {
        for (let y = 0; y < boxes; y++) {
            grid[getGridIndex(x, y)] = {
                color: colors[Math.floor(Math.random() * colors.length)],
                beating: 0,
            };

        }
    }


    const getGridCoordinates = (x: number, y: number) => {
        const xRatio = x / canvasW;
        const yRatio = y / canvasH;

        return {
            gridX: Math.floor(xRatio * boxes),
            gridY: Math.floor(yRatio * boxes),
        }
    }

    const getSquareValueFromGrid = (x: number, y: number) =>
        grid[getGridIndex(x, y)]

    const getSquareValueFromPixels = (x: number, y: number) => {
        const { gridX, gridY } = getGridCoordinates(x, y)
        const v = getSquareValueFromGrid(gridX, gridY);
        if (!v) debugger;
        return v;
    }

    const setSquareValueFromPixels = (x: number, y: number, c: string) => {
        const { gridX, gridY } = getGridCoordinates(x, y);
        const index = getGridIndex(gridX, gridY);
        const cell = grid[index];
        if (!!cell) {
            cell.beating++;
            if (cell.beating >= lives) {
                grid[index] = { color: c, beating: 0 };
            }
        }
    }

    const draw = (ctx: CanvasRenderingContext2D) => {
        // ctx.fillStyle = "#eee";
        // ctx.fillRect(0, 0, w, h);

        // draw background

        const boxW = canvasW / boxes;
        const boxH = canvasH / boxes;

        for (let x = 0; x < boxes; x++) {
            for (let y = 0; y < boxes; y++) {
                const c = getSquareValueFromGrid(x, y);

                const dead = lives === 0 ? 0 : c.beating / lives;

                ctx.fillStyle = c.color;
                const xx = boxW * x;
                const yy = boxH * y;
                ctx.fillRect(xx, yy, boxW, boxH);

                var deadColor = Color(c.color).darken(dead / 2).hex();
                ctx.fillStyle = deadColor;//"#000";
                const paddingH = boxH * (1 - dead);
                const paddingW = boxW * (1 - dead);
                ctx.fillRect(xx + (paddingW / 2), yy + (paddingH / 2), boxW - paddingW, boxH - paddingH);

            }
        }

        // draw the balls
        for (let i = 0; i < balls.length; i++) {
            const b = balls[i];

            const hitGridL = getSquareValueFromPixels(b.x - rad, b.y).color !== b.squareColor;
            const hitGridR = getSquareValueFromPixels(b.x + rad, b.y).color !== b.squareColor;
            const hitGridT = getSquareValueFromPixels(b.x, b.y - rad).color !== b.squareColor;
            const hitGridB = getSquareValueFromPixels(b.x, b.y + rad).color !== b.squareColor;

            if (hitGridL) setSquareValueFromPixels(b.x - rad, b.y, b.squareColor);
            if (hitGridR) setSquareValueFromPixels(b.x + rad, b.y, b.squareColor);
            if (hitGridT) setSquareValueFromPixels(b.x, b.y - rad, b.squareColor);
            if (hitGridB) setSquareValueFromPixels(b.x, b.y + rad, b.squareColor);

            const hitEdgeX = b.x - rad < 0 || b.x + rad > canvasW;
            const hitEdgeY = b.y - rad < 0 || b.y + rad > canvasH;

            if (hitEdgeX || hitGridL || hitGridR) b.dx = -b.dx;
            if (hitEdgeY || hitGridT || hitGridB) b.dy = -b.dy;

            const aHit = hitGridL || hitGridR || hitGridT || hitGridB;

            if (aHit) b.bashCount++;

            const vel = 1 - ((b.bashCount % rhythm) / rhythm);
            if (aHit) ins.play(b.sound, vel);


            ctx.beginPath();
            // ctx.fillStyle = "#" + ballColor.color;
            ctx.fillStyle = "#fff";
            // Draws a circle of radius 20 at the coordinates 100,100 on the canvas
            ctx.arc(b.x, b.y, rad, 0, Math.PI * 2, true);
            ctx.closePath();
            ctx.fill();

            // if (aHit && !allSides) ins.play("C4");
            // if (hitEdgeX || hitEdgeY) ins.play("G4");

            // add the delta to the x and y.. 
            // also double make sure we aren't over the edge (possibly a rounding issue)
            if (b.x - rad < 0) {
                b.x = rad;
            }
            else if (b.x + rad > canvasW) {
                b.x = canvasW - rad;
            }
            else {
                b.x += b.dx;
            }

            if (b.y - rad < 0) {
                b.y = rad;
            }
            else if (b.y + rad > canvasH) {
                b.y = canvasH - rad;
            }
            else {
                b.y += b.dy;
            }

        }

    }

    const balls = Array.from(new Array(dotCount))
        .map((n, i) => ({
            x: Math.random() * canvasW,
            y: Math.random() * canvasH,
            dx: speed,
            dy: speed,
        }))
        .map((b, i) => ({
            x: b.x,
            y: b.y,
            sound: Math.random(),
            ins,
            bashCount: 0,
            dx: b.dx,
            dy: b.dy,
            squareColor: getSquareValueFromPixels(b.x - b.dx, b.y).color,


        }));



    return {
        balls,
        grid,
        boxes,
        canvas: {
            width: canvasW,
            height: canvasH,
        },
        draw,
        setCanvas: (w: number, h: number) => {
            canvasH = h;
            canvasW = w
        },
        getSquareValueFromGrid,
        getSquareValueFromPixels,
        setSquareValueFromPixels,
    }
}

export type GridModel = ReturnType<typeof gridy>

